import AuditFormComponent from './AuditFormComponent';

export default AuditFormComponent;

export type {};
